export default {
    'common.auto.connect': 'Auto Connect',
    'common.connect.status': 'Connection Status',
    'common.client.url': 'Client URL'
};
